import { MdxPage } from '@features/mdx/MdxPage';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '48e63367-b425-4f83-ba50-a33c4ef0d352',
	[AppLanguageCodes.SK]: '48e63367-b425-4f83-ba50-a33c4ef0d352',
	[AppLanguageCodes.DE]: '48e63367-b425-4f83-ba50-a33c4ef0d352',
}


export const About = () => {

	return (
		<MdxPage className='about-page' articleIds={articleIds}>
		</MdxPage>
	);
};